import React, {useContext} from 'react'
import AuthContext from '../context/AuthContext'
import '../assets/css/register.css';
import logo from '../assets/images/logo.jpeg'
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  let {registerUser} = useContext(AuthContext)

  return (
    <div className='text-center'>
        {/* <form onSubmit={registerUser}>
            <input type="text" name="username" placeholder='Enter Username' />
            <input type="email" name="email" placeholder='Enter Email' />
            <input type="text" name="first_name" placeholder='Enter Firstname' />
            <input type="text" name="last_name" placeholder='Enter Lastname' />
            <input type="password" name="password" placeholder='Enter Password' />
            <select name="company">
                <option value={1}>Yusr</option>
                <option value={2}>Hatem</option>
            </select>
            <input type="submit" />
        </form> */}

        <main className="form-signin w-100 m-auto">
            <form onSubmit={registerUser}>
                <img className="mb-4" src={logo} alt="" width="300" />
                <h1 className="h3 mb-3 fw-normal">Please register a new account</h1>

                <div className="form-floating">
                <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com" name='email' />
                <label htmlFor="floatingInput">Email address</label>
                </div>
                <div className="form-floating">
                <input type="text" className="form-control" id="floatingInput1" placeholder="username" name='username' />
                <label htmlFor="floatingInput">Username</label>
                </div>
                <div className="form-floating">
                <input type="text" className="form-control" id="floatingInput2" placeholder="firstname" name='first_name' />
                <label htmlFor="floatingInput">First name</label>
                </div>
                <div className="form-floating">
                <input type="text" className="form-control" id="floatingInput2" placeholder="lastname" name='last_name' />
                <label htmlFor="floatingInput">Last name</label>
                </div>
                <div className="form-floating">
                    <select className="form-control" name='company'>
                        <option value={1}>Yusr</option>
                        <option value={2}>Hatem</option>
                    </select>
                </div>
                <div className="form-floating">
                <input type="password" className="form-control" id="floatingPassword" placeholder="Password" name='password'/>
                <label htmlFor="floatingPassword">Password</label>
                </div>

                <input type="submit" className="w-100 btn btn-lg btn-primary" value="Register" />
                <Link className='mt-5 text-muted' to="/login">Have an account? Login</Link>
                <p className="mt-2 mb-3 text-muted">Hamsie Expenses &copy; 2023</p>
            </form>
        </main>
    </div>
  )
}

export default RegisterPage